function comparisonValues(value) {
    if (Array.isArray(value)) return value.map((item) => String(item ?? '').trim());
    return String(value ?? '').split(',').map((item) => item.trim());
}

// Matches the same generic operators supported by showIf. Keeping this helper
// independent of React makes conditional labels usable in Add/Edit forms and
// straightforward to test without module- or field-specific code.
export function conditionMatches(condition, value) {
    if (!condition?.field) return false;
    switch (condition.operator ?? 'eq') {
        case 'eq': return String(value ?? '') === String(condition.value ?? '');
        case 'neq': return String(value ?? '') !== String(condition.value ?? '');
        case 'truthy': return value !== undefined && value !== null && value !== '' && value !== false;
        case 'falsy': return value === undefined || value === null || value === '' || value === false;
        case 'notEmpty': return Array.isArray(value) ? value.length > 0 : Boolean(value);
        case 'in': return comparisonValues(condition.value).includes(String(value ?? ''));
        case 'notIn': return !comparisonValues(condition.value).includes(String(value ?? ''));
        default: return false;
    }
}

export function configuredFieldLabel(field, watchedValue, combined = false) {
    const fallback = combined
        ? (field?.combineLabel ?? field?.label)
        : field?.label;
    const rule = field?.labelWhen;
    return conditionMatches(rule, watchedValue) && rule?.label
        ? rule.label
        : fallback;
}

export function conditionFieldPath(condition, siblingPrefix) {
    if (!condition?.field) return ['__noop_conditional_label__'];
    return siblingPrefix != null
        ? [...(Array.isArray(siblingPrefix) ? siblingPrefix : [siblingPrefix]), condition.field]
        : [condition.field];
}
